import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Security } from '@okta/okta-react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { oktaAuth } from './lib/okta-auth';
import { SecureRoute } from './components/SecureRoute';
import { LoginCallback } from './pages/LoginCallback';
import { Login } from './pages/Login';
import { DashboardLayout } from './pages/DashboardLayout';
import { Overview } from './pages/Overview';
import AgentsPage from './pages/AgentsPage';
import AgentDetailPage from './pages/AgentDetail';
import { ResourcesPage } from './pages/ResourcesPage';
import { AuditLog } from './pages/AuditLog';
import { EventLog } from './pages/EventLog';
import DCRSettings from './pages/DCRSettings';
import UserSessions from './pages/UserSessions';

function App() {
  const restoreOriginalUri = async (_oktaAuth: OktaAuth, originalUri: string) => {
    window.location.replace(toRelativeUrl(originalUri || '/dashboard', window.location.origin));
  };

  return (
    <BrowserRouter>
      <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/callback" element={<LoginCallback />} />

          <Route element={<SecureRoute />}>
            <Route path="/dashboard" element={<DashboardLayout />}>
              <Route index element={<Overview />} />
              <Route path="agents" element={<AgentsPage />} />
              <Route path="agents/:agentId" element={<AgentDetailPage />} />
              <Route path="resources" element={<ResourcesPage />} />
              <Route path="audit" element={<AuditLog />} />
              <Route path="event-log" element={<EventLog />} />
              <Route path="sessions" element={<UserSessions />} />
              <Route path="settings/dcr" element={<DCRSettings />} />
            </Route>
          </Route>
        </Routes>
      </Security>
    </BrowserRouter>
  );
}

export default App;
